import React, {useEffect} from 'react';
import {UiBox, UiCenter, UiImage, UiText} from '~/components/elements';
import {trackPageViewGA} from '~/services/google-analytics';

const RebookingAppointmentFail = () => {
  useEffect(() => {
    trackPageViewGA('/rebooking-appointment-fail', 'Rebooking Appointment Fail');
  }, []);
  return (
    <UiBox px={4}>
      <UiCenter>
        <UiImage type="icon" name="ease-logo" width="120px" mt={6} />
      </UiCenter>
      <UiBox mt="50px">
        <UiText textAlign="center" fontSize={['33px', '40px']} fontWeight="500" mb="20px">
          Oops, you seem to be making a duplicate booking.
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          Your appointment has been reserved for another time.
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          If you want to reschedule your upcoming appointment, please reach out to us at
        </UiText>
        <UiText textAlign="center" fontSize="md">
          customer.care@ease-healthcare.com.
        </UiText>
        <UiText textAlign="center" fontSize="md" mt={10}>
          The Ease Healthcare Team
        </UiText>
      </UiBox>
    </UiBox>
  );
};

export default RebookingAppointmentFail;
